import React, { useEffect } from 'react';
import ErrorBoundary from './components/common/ErrorBoundary';
import Header from './components/layout/Header';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Projects from './components/sections/Projects';
import Contact from './components/sections/Contact';
import Footer from './components/layout/Footer';
import MouseTracker from './components/effects/MouseTracker';
import { initContentProtection } from './utils/contentProtection';
import { initAntiTampering } from './utils/antiTampering';
import './styles/modern.css';

function App() {
  // useEffect(() => {
  //   // Initialize all security measures
  //   initContentProtection();
  //   initAntiTampering();
  // }, []);

  return (
    <ErrorBoundary>
      <div className="App">
        <MouseTracker />
        <Header />
        <main>
          <section id="home">
            <Hero />
          </section>
          <section id="about">
            <About />
          </section>
          <section id="projects">
            <Projects />
          </section>
          <section id="contact">
            <Contact />
          </section>
        </main>
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;